import React from 'react';
import ReactDOM from 'react-dom';

class InfoBall extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showText: false
        };
    }

    componentDidMount() {
        document.addEventListener('click', this.handleClickOutside, true);
    }
    
    componentWillUnmount() {
        document.removeEventListener('click', this.handleClickOutside, true);
    }
    
    handleClickOutside = event => {
        const domNode = ReactDOM.findDOMNode(this);
        if (!domNode || !domNode.contains(event.target)) {
            this.setState({showText: false});
        }
    }
    
    render() {
        return (
            <div className={"info-ball"+(this.state.showText ? " info-ball--open" : "")}>
                <div className="info-ball__text">{this.props.text}</div>
                <button className="info-ball__button" onClick={() => {this.setState({showText:!this.state.showText})}}><i></i></button>
            </div>
        );
    }
}

export default InfoBall;